import Vue from 'vue'
import App from '@/models/App'

const globalMixin = {
    metaInfo: {
        titleTemplate: 'MARITIME7 - %s',
    },
    data() {
        return {}
    },
    computed: {
        tableHeight() {
            return App.one().height / 2 + 'px'
        },
        language: {
            get: function () {
                const localValue = localStorage.getItem('m7_lang')
                if (localValue) {
                    this.$i18n.locale = localValue
                    this.validationLocale = localValue
                    return localValue
                } else {
                    return App.one().language
                }
            },
            set: function (newValue, oldValue) {
                this.$i18n.locale = newValue != oldValue ? newValue : oldValue
                this.validationLocale = this.$i18n.locale
                localStorage.setItem('m7_lang', newValue)
                App.setLanguage(newValue)
            },
        },
        isDevelopment() {
            return process.env.VUE_APP_ENV_MODE !== 'production' ? true : false
        },
        isGuest() {
            return App.one().isGuest
        },
        isMember() {
            return App.one().isMember
        },
        isTouch() {
            return App.one().isTouch
        },
        isPC() {
            return App.one().isPC
        },
        isMobile() {
            return App.one().isMobile
        },
        isTablet() {
            return App.one().isTablet
        },
        isDesktop() {
            return App.one().isDesktop
        },
        isWideScreen() {
            return App.one().isWideScreen
        },
        isFullHD() {
            return App.one().isFullHD
        },
        isLoading() {
            return App.one().logading
        },
        isTouchDevice() {
            return App.one().isTouchDevice
        },
    },
    methods: {
        nl2br(v) {
            return v.replace(/\n/g, '<br/>')
        },
        currency(v, c) {
            return new Intl.NumberFormat(this.language, {
                style: 'currency',
                currency: c,
            }).format(v)
        },
        $notify(type, message, icon) {
            this.$buefy.notification.open({
                message: `<strong>${message}</strong>`,
                type,
                position: 'is-bottom',
                duration: 5000,
                'has-icon': type === 'is-error' || !!icon,
                icon: icon
                    ? icon
                    : type === 'is-error'
                      ? 'alert-outline'
                      : undefined,
            })
        },
        isLaborReNewalAfter() {
            // 日本時間の2025年7月7日から31日までを判定
            const startDate = new Date('2025-07-05T00:00:00+09:00'); // 日本時間 7月7日 00:00
            const endDate = new Date('2025-08-01T00:00:00+09:00'); // 日本時間 8月1日 00:00(7月31日まで)
            const currentDate = new Date();
            return currentDate >= startDate && currentDate < endDate;
        },
        isLaborClosed() {
            // 日本時間の2025年8月1日以降を判定
            const closedDate = new Date('2025-07-31T00:00:00+09:00'); // 日本時間 8月1日 00:00
            const currentDate = new Date();
            return currentDate >= closedDate;
        },
        newLaborSite(blank = true) {
            const token = this.$cookies.get('_t');
            let newUrl = 'https://labour.maritime7.com/login';
            if (token) {
                switch (process.env.VUE_APP_ENV_MODE) {
                    case 'local':
                        newUrl = `https://labour.maritime7.com/auth?token=${token}`;
                        break;
                    case 'test':
                        newUrl = `https://labour.maritime7.work/auth?token=${token}`;
                        break;
                    case 'demo':
                        newUrl = `https://labour.maritime7.net/auth?token=${token}`;
                        break;
                    default:
                        newUrl = `https://labour.maritime7.com/auth?token=${token}`;
                }
            }
            if (!blank) {
                window.open(newUrl, '_self');
                return;
            } else {
                window.open(newUrl, '_blank');
            }
        },
    },
}

Vue.mixin(globalMixin)

export default globalMixin
